module.exports = __webpack_public_path__ + "static/media/settings.e8148c19.png";